import React from "react";
import {useTranslation} from "react-i18next";
import PageHeader from "../../../components/layout/page/PageHeader";
import Button from "../../../components/ui/Button";
import {TAKEOFFS_VERSIONS, TakeoffsVersion} from "../../../utils/takeoffsVersion";
import {useSwitchVersion} from "./useSwitchVersion";

const CURRENT: TakeoffsVersion = "classic";

const LABELS = {
	classic: "settings.defaultView.classicLabel",
	new: "settings.defaultView.newLabel",
	ai: "settings.defaultView.aiLabel",
} as const;

/** Switches version now. The current one is selected and choosing it does nothing. */
const DefaultViewSetting: React.FC = () => {
	const {t} = useTranslation(undefined, {useSuspense: false});
	const switchVersion = useSwitchVersion();

	const choose = (version: TakeoffsVersion) => {
		if (version === CURRENT) return;
		switchVersion(version);
	};

	return (
		<>
			<PageHeader>
				<div className={"settings-main_title"}>
					{t("settings.defaultView.title")}
				</div>
			</PageHeader>
			<div className={"settings-main_versions"} role="group" aria-label={t("settings.defaultView.title")}>
				{TAKEOFFS_VERSIONS.map(version => (
					<Button key={version}
							label={t(LABELS[version])}
							variant={version === CURRENT ? "secondary" : "optional"}
							ariaPressed={version === CURRENT}
							onClick={() => choose(version)}/>
				))}
			</div>
		</>
	);
};

export default DefaultViewSetting;
